import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import RtlProvider from "../../../Components/RtlProvider";
import { ContextNotification, severitys } from "../../../App";
import reservationApi from "../../../api/reservationApi";
import { Box, Button, Checkbox, FormControlLabel, Grid, IconButton, Modal, Paper, Tooltip, Typography, useTheme } from "@mui/material";
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { ContextUserInfo } from "../MainPanel";
import AccessControl from "../../../Components/AccessControl";

import {
    MaterialReactTable,
    useMaterialReactTable,
} from 'material-react-table';
import { MdEdit, MdEditSquare, MdExpandLess, MdExpandMore } from "react-icons/md";
import { NavLink } from "react-router-dom";
import logApi from "../../../api/logApi";
import staticVariablesApi from "../../../api/staticVariablesApi";
import helper from "../../../helper";
import { RHFAutocomplete } from "../../../Components/RHFAutocomplete";
import ActiveCurrentReservationForm from "./ActiveCurrentReservationForm";
import enumMapper from "../../../enumMapper";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import gregorian from "react-date-object/calendars/gregorian"
import gregorian_en from "react-date-object/locales/gregorian_en"
import moment from 'jalali-moment'
import CustomDateInput from "../../../Components/CustomDateInput";


const PlanErrorLogList = () => {
    const theme = useTheme();
    //light or dark green
    const baseBackgroundColor =
        theme.palette.mode === 'dark'
            ? 'rgba(3, 44, 43, 1)'
            : '#fff';
    const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
    const { open, setOpen } = useContext(ContextNotification);

    //data and fetching state
    const [data, setData] = useState([]);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [rowCount, setRowCount] = useState(0);
    //table state
    const [columnFilters, setColumnFilters] = useState(
        [],
    );
    const [globalFilter, setGlobalFilter] = useState('');
    const [sorting, setSorting] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });

    const [refresh, setRefresh] = useState(false);
    const [AppLogicCodes, setAppLogicCodes] = useState([]);
    const [selectedErrorLog, setSelectedErrorLog] = useState(null);

    const columns = useMemo(
        () => [
            {
                accessorKey: 'recordNumber',
                header: 'ردیف',
                size: 100,
                enableSorting: false,
            },

            {
                accessorKey: 'data.appLogicCodeTitle',
                id: 'appLogicCodeTitle',
                header: 'appLogicCodeTitle',
                size: 150,
                enableSorting: false,
            },
            {
                accessorKey: 'createOn',
                id: 'createOn',
                header: 'تاریخ ایجاد',
                size: 250,
                enableSorting: true,
                Cell: ({ cell, row }) => (
                    row.original.data.createOn

                ),
            },
            {
                accessorKey: 'FromDate',
                id: 'FromDate',
                header: 'از تاریخ',
                size: 150,
                enableSorting: false,
                Cell: ({ cell, row }) => (
                    JSON.parse(row.original.data.message).FromDate

                ),
            },

            {
                accessorKey: 'ToDate',
                id: 'ToDate',
                header: 'تا تاریخ',
                size: 150,
                enableSorting: false,
                Cell: ({ cell, row }) => (
                    JSON.parse(row.original.data.message).ToDate

                ),
            },
            {

                id: 'PlanCode',
                header: 'کد پلان',
                size: 150,
                enableSorting: true,
                Cell: ({ cell, row }) => (
                    JSON.parse(row.original.data.message).PlanCode

                ),
            },
            {

                id: 'DispatchOfTheDay',
                header: 'اعزام روز',
                size: 150,
                enableSorting: true,
                Cell: ({ cell, row }) => (
                    JSON.parse(row.original.data.message).DispatchOfTheDay

                ),
            },






        ],
        [],
    );



    const table = useMaterialReactTable({
        columns,
        data,
        enableRowSelection: true,
        // getRowId: (row) => row.phoneNumber,

        manualFiltering: true,
        manualPagination: true,
        manualSorting: true,
        muiToolbarAlertBannerProps: isError
            ? {
                color: 'error',
                children: 'Error loading data',
            }
            : undefined,
        onColumnFiltersChange: setColumnFilters,
        onGlobalFilterChange: setGlobalFilter,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        rowCount,
        state: {
            columnFilters,
            globalFilter,
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            sorting,
        }
        , localization: {

            sortByColumnAsc: '',
            sortByColumnDesc: '',
            sortedByColumnAsc: '',
            sortedByColumnDesc: '',

            // ... and many more - see link below for full list of translation keys
        },

        enableFilters: false,
        enableRowSelection: false
        , muiTableHeadCellProps: {
            //simple styling with the `sx` prop, works just like a style prop in this example
            sx: {
                textAlign: "left",
                backgroundColor: '#86A7FC'
            },
        },
        muiTableBodyCellProps: {
            sx: {
                textAlign: 'left'
            },
        },
        muiTableBodyProps: {
            // sx: (theme) => ({
            //   '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]) > td':
            //   {
            //     backgroundColor: darken(baseBackgroundColor, 0.1),
            //   },
            //   '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
            //   {
            //     backgroundColor: darken(baseBackgroundColor, 0.2),
            //   },
            //   '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]) > td':
            //   {
            //     backgroundColor: lighten(baseBackgroundColor, 0.1),
            //   },
            //   '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
            //   {
            //     backgroundColor: darken(baseBackgroundColor, 0.2),
            //   },
            // }),
        },
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,
            draggingBorderColor: theme.palette.secondary.main,
        }),

        muiTableBodyRowProps: ({ row }) => ({
            sx: {
                backgroundColor: 'normal',
            },
        }),

        enableRowActions: true,
        positionActionsColumn: 'last',
        displayColumnDefOptions: {
            'mrt-row-actions': {
                header: '', //change header text
                size: 300, //make actions column wider

            },
            'mrt-row-expand': {
                header: '', //change header text
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
            },
        },
        renderRowActions: ({ row, table }) => (

            <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                {
                    AccessControl.checkPermissions(userPermissions, ["Reservation:ActiveCurrentReservation"]) &&
                    row.original.data.appLogicCode === enumMapper.AppLogicCode.PlanIsBooked &&
                    <Button variant="contained" onClick={() => {
                        handleOpenActiveCurrentReservationModal(row.original.data)
                    }} sx={{ whiteSpace: 'nowrap' }}>
                        بررسی
                    </Button>
                }
            </Box>
        ),


    });

    const schema = yup.object().shape({

    });
    const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({
        defaultValues: {
            appLogicCode: "0",
        },
        resolver: yupResolver(schema),
    });

    const getfilteritems = () => {
        const appLogicCode = watch("appLogicCode");
        //from
        let fromGregorian = null;
        if (watch("from")) {
            let from = new DateObject({
                date: watch("from"),
                calendar: persian,
                locale: persian_fa
            });

            var fromStr = from.year + '/' + from.month.number + '/' + from.day;
            fromGregorian = moment.from(fromStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
        }

        //to
        let toGregorian = null;
        if (watch("to")) {
            let to = new DateObject({
                date: watch("to"),
                calendar: persian,
                locale: persian_fa
            });

            var toStr = to.year + '/' + to.month.number + '/' + to.day;
            toGregorian = moment.from(toStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
        }
        const filterItems = [];

        // watch("brokerId") && filterItems.push({
        //       "propertyName": "BrokerGroupInfo.BrokerId",
        //       "operator": enumMapper.FilterOperator.Equals,
        //       "value": watch("brokerId")
        //     })

        const filterData = {
            "appLogicCode": parseInt(appLogicCode),
            "from": fromGregorian,
            "to": toGregorian,
            "orderBy": sorting.length > 0 ? sorting[0].id : 'CreateOn',
            "orderDescending": sorting.length > 0 ? sorting[0].desc : true,
            "pageSize": pagination.pageSize,
            "pageNumber": pagination.pageIndex + 1
        }
        return filterData;
    }

    const onSubmit = (data) => {
        const filterData = getfilteritems();
        GetData(filterData);
    };

    useEffect(() => {
        GetAppLogicCodeDropDown();
    }, [])

    useEffect(() => {
        const paginationModel = getfilteritems();
        GetData(paginationModel);
    }, [refresh,
        columnFilters, //re-fetch when column filters change
        globalFilter, //re-fetch when global filter changes
        pagination.pageIndex, //re-fetch when page index changes
        pagination.pageSize, //re-fetch when page size changes
        sorting, //re-fetch when sorting changes
    ]);

    const GetData = (filterData) => {
        if (!data.length) {
            setIsLoading(true);
        } else {
            setIsRefetching(true);
        }
        logApi.FilterForPlan(filterData)
            .then((res) => {
                setData(res.data.data.items);
                const rowcnt = res.data.data.totalCount;
                setRowCount(rowcnt);
            })
            .catch((error) => {
                console.log(error);
                setIsError(true);
            }).finally(() => {
                setIsError(false);
                setIsLoading(false);
                setIsRefetching(false);
            });
    }

    const RefreshGrid = (result) => {
        if (result)
            setRefresh(old => !old);
        handleCloseActiveCurrentReservationModal();
    }

    const GetAppLogicCodeDropDown = () => {
        staticVariablesApi.GetAppLogicCodeDropDown()
            .then((res) => {
                const arr = helper.DictionayToList(res.data.data)
                const mappedReponse = arr.map((r) => {
                    return {
                        id: r.key,
                        label: r.value
                    };
                });
                setAppLogicCodes(mappedReponse);
            })
            .catch((error) => console.log(error));
    };
    const handleAppLogicCodeChanged = () => { }

    const [openActiveCurrentReservationModal, setOpenActiveCurrentReservationModal] = useState(false);
    const handleOpenActiveCurrentReservationModal = (row) => {

        setSelectedErrorLog(row)
        setOpenActiveCurrentReservationModal(true);
    };
    const handleCloseActiveCurrentReservationModal = () => {

        setSelectedErrorLog(null);
        setOpenActiveCurrentReservationModal(false);
    };
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '400px',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 6,
    };
    return (
        <RtlProvider>
            <form onSubmit={handleSubmit(onSubmit)}>

                <Typography component="h1" variant="h5" mb={2}>لاگ</Typography>
                <Grid container spacing={1}>

                    <Grid item xs={12} sm={2}>
                        <RHFAutocomplete
                            control={control}
                            options={AppLogicCodes ?? []}
                            name="appLogicCode"
                            placeholder="appLogicCode"
                            onChange={handleAppLogicCodeChanged}
                            disabled={AppLogicCodes === null}
                        />
                    </Grid>

                    <Grid item xs={12} sm={2}>
                        <Controller
                            control={control}
                            name="from"
                            rules={{ required: true }}
                            render={({
                                field: { onChange, name, value },
                                fieldState: { invalid, isDirty },
                            }) => (
                                <>
                                    <DatePicker
                                        value={value || ""}
                                        onChange={(date) => {
                                            onChange(date?.isValid ? date : "");
                                        }}
                                        format={"YYYY/MM/DD"}
                                        calendar={persian}
                                        locale={persian_fa}
                                        calendarPosition="bottom-right"
                                        render={<CustomDateInput label={"از تاریخ"} />}
                                    />
                                </>
                            )}
                        />
                    </Grid>

                    <Grid item xs={12} sm={2}>
                        <Controller
                            control={control}
                            name="to"
                            rules={{ required: true }}
                            render={({
                                field: { onChange, name, value },
                                fieldState: { invalid, isDirty },
                            }) => (
                                <>
                                    <DatePicker
                                        value={value || ""}
                                        onChange={(date) => {
                                            onChange(date?.isValid ? date : "");
                                        }}
                                        format={"YYYY/MM/DD"}
                                        calendar={persian}
                                        locale={persian_fa}
                                        calendarPosition="bottom-right"
                                        render={<CustomDateInput label={"تا تاریخ"} />}
                                    />
                                </>
                            )}
                        />
                    </Grid>

                    <Grid item xs={12} sm={10}>
                        <Button type="submit" variant="contained" color="secondary">جستجو</Button>
                    </Grid>
                </Grid>

            </form>
            <Box sx={{ display: "flex", flexDirection: 'column' }}>

                <Box sx={{ textAlign: "right", mb: 2, mr: 1.5 }}>تعداد نتایج: {rowCount}</Box>
            </Box>
            <MaterialReactTable table={table} />
            <Modal
                open={openActiveCurrentReservationModal}
                onClose={handleCloseActiveCurrentReservationModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <RtlProvider>
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            بررسی
                        </Typography>
                        <Box id="modal-modal-description" sx={{ mt: 2 }}>
                            <ActiveCurrentReservationForm row={selectedErrorLog} refreshGrid={RefreshGrid} />
                        </Box>
                    </Box>
                </RtlProvider>
            </Modal>
        </RtlProvider>
    );
}

export default PlanErrorLogList;
